<template>
  <div>
    <CommonExpansionPanel>
      <template v-slot:title-panel>
        Roles y funciones
      </template>

      <v-expansion-panel-content>
        <ViewData
          v-if="switch_data === 1"
          :personalData="personalData"
          :listings="listings"
          :canEdit="canEdit"
          @changeComponent="changeComponent"
        />

        <EditData
          v-else
          :personalData="personalData"
          :routesConfig="routesConfig"
          :listings="listings"
          @changeComponent="changeComponent"
        />
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import ViewData from "./ViewData.vue";
import EditData from "./EditData.vue";
import { mainAxios } from "@/mainAxios.js";
import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";
import { getAreaNegocio } from "@/services/log/log.service.js";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service.js";

export default {
  name: "RolesDataPanel",
  components: {
    CommonExpansionPanel,
    ViewData,
    EditData,
  },
  props: {
    personalData: Object,
    routesConfig: Object,
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      switch_data: 1,
      listings: {
        ramoList: [],
        canalList: [],
        landings: [],
        roles: [],
        status: [],
        empresas: [],
        areasNegocios: [],
        cuentasCorreo: [],
        callCenter:[],
        areasAgente: [],
        estatusAsignacion: [],
      },
      config: {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      },
      roles: [],
      rol: "",
    };
  },
  watch: {
    // mismas reglas que en PersonalDataPanel
    rol(val) {
      this.listings.roles = [];
      let permitedRoles = [];
      switch (val) {
        case "ADMIN":
        case "ADMINAGENT":
          this.listings.roles = this.roles;
          return;
        case "MANAGER":
          permitedRoles = ["AGENT", val];
          break;
        case "ADMINCC":
          permitedRoles = [
            "AGENTCC",
            "AGENTCCSPONSORS",
            "MANAGERCC",
            "OPERADORCC",
            "RENOVACIONESCC",
            "VALIDADORCC",
            val,
          ];
          break;
        case "MANAGERCC":
          permitedRoles = [
            "AGENTCC",
            "AGENTCCSPONSORS",
            "OPERADORCC",
            "RENOVACIONESCC",
            val,
          ];
          break;
        case "OPERACIONES":
          permitedRoles = ["OPERADOR", "AGENT", val];
          break;
        case "OPERADOR":
          permitedRoles = ["AGENT", val];
          break;
        case "MANAGEREMAILS":
          permitedRoles = [
            "BACKOFFICEEMAILS",
            "OPERACIONESEMAILS",
            "MANAGEREMAILS",
            "MONITORECIPORTAL"
          ];
          break;
        case "OPERACIONESINBOUND":
          permitedRoles = [
            "BACKOFFICEINBOUND",
            "MESACONTROLINBOUND",
            "OPERACIONESINBOUND",
            "OPERADORINBOUND",
            "MONITORECIPORTAL"
          ];
          break;
        case "AGENTCORP":
          permitedRoles = ["AGENT", val];
          break;
        case "GERENTEPOSTVENTA":
          permitedRoles = [
            "BACKOFFICEEMAILS",
            "OPERACIONESINBOUND",
            "OPERACIONESEMAILS",
            "MANAGEREMAILS",
            "OPERADORINBOUND",
            "MONITORECIPORTAL",
            this.rol,
          ];
          break;
        default:
          permitedRoles = [val];
          break;
      }
      permitedRoles.forEach((rol) => {
        const rolEncontrado = this.roles.find((r) => r.id === rol);
        if (rolEncontrado) this.listings.roles.push(rolEncontrado);
      });
    },
  },
  methods: {
    changeComponent(component) {
      this.switch_data = component;
      this.$emit("getData");
    },
    async listas() {
      // Ramo
      mainAxios.get(`/v1/ramo/list`, this.config).then((response) => {
        this.listings.ramoList = response.data;
      });

      // Canales
      mainAxios.get(`/v1/canal/list`, this.config).then((response) => {
        this.listings.canalList = response.data;
      });

      // Landings / productos
      mainAxios.get(`/v1/agente/landing/list`, this.config).then((response) => {
        this.listings.landings = response.data;
      });

      mainAxios.get(`/v1/catalog-call-center`, this.config).then((response) => {
        this.listings.callCenter = response.data;
      });


      // Roles
      mainAxios.get(`/v1/agente/roles/list`, this.config).then((response) => {
        response.data &&
          response.data.map((element) => {
            this.roles.push({
              id: element.rol ? element.rol : "No tiene",
              nombre: element.nombre ? element.nombre : "No tiene",
              area_negocio: element.area_negocio ?? null,
            });
          });

        this.roles.sort((a, b) => {
          const nombreA = a.nombre.toUpperCase();
          const nombreB = b.nombre.toUpperCase();
          if (nombreA < nombreB) return -1;
          if (nombreA > nombreB) return 1;
          return 0;
        });

        this.rol = JSON.parse(localStorage.getItem("roles"))[0].rol;
      });

      // Empresas
      const respEmp = await getEmpresasInbound();
      this.listings.empresas = respEmp.data.empresas || [];

      // Áreas de negocio
      const areas = await getAreaNegocio();
      this.listings.areasNegocios = areas.map((e) => ({
        id: e.id,
        departamento: e.departamento,
        nombre: `${e.areas} - ${e.departamento} - ${e.proceso}`,
      }));

      const rolNotAdmin = localStorage.getItem("rolNotAdmin");
      if (rolNotAdmin && rolNotAdmin.includes("INBOUND")) {
        this.listings.areasNegocios = this.listings.areasNegocios.filter(
          (e) => e.departamento === "POST-VENTA"
        );
      }

      // status para mostrar en selects si llegas a ocuparlos aquí
      this.listings.status = [
        { id: 0, name: "Nuevo" },
        { id: 1, name: "Activo" },
        { id: 2, name: "Inactivo" },
        { id: -1, name: "Baja" },
      ];

      // Área del agente (catálogo fijo, espeja common/constants/AreaAgente.java)
      this.listings.areasAgente = [
        { id: 0, name: "Sin asignar" },
        { id: 1, name: "Renovación" },
        { id: 2, name: "Cobranza" },
        { id: 3, name: "Ventas" },
        { id: 4, name: "Servicio al cliente" },
        { id: 5, name: "Back Office" },
      ];

      // Estatus de asignación (catálogo fijo, espeja common/constants/EstatusAgente.java)
      // NO confundir con listings.status (alta/baja del usuario en el CRM)
      this.listings.estatusAsignacion = [
        { id: 1, name: "Activo", color: "#4caf50", icon: "mdi-circle" },
        { id: 2, name: "Pausa", color: "#ff9800", icon: "mdi-circle" },
        { id: 3, name: "Inactivo", color: "#f44336", icon: "mdi-circle" },
      ];

      // Cuentas correo
      const body = { pagina: 1, elementosPagina: 500 };
      const respCC = await getCuentasCorreoListByParams(body);
      this.listings.cuentasCorreo = respCC.cuentas ?? [];
    },
  },
  mounted() {
    this.listas();
  },
};
</script>
